const NewJobsEnum = Object.freeze({
  Čeština: 'Zobrazit pouze nová pracovní místa',
  Deutsch: 'Nur neue Jobs anzeigen',
  Français: 'Nouveaux emplois uniquement',
  Slovenčina: 'Zobraziť len nové pracovné miesta',
  Español: 'Mostrar sólo los trabajos nuevos',
  English: 'Only Show New Jobs',
})

export default NewJobsEnum
